<script lang="ts">
export default {
  name: 'KkTooltip',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'
import { KkIcon } from '../index'

export interface Props {
  isVisible: boolean
  width: string
  top?: string
  bottom?: string
  left?: string
  label?: string
  zIndex?: number
  iconColor?: string
  iconWidth?: string
  fontWeight?: string
  fontSize?: string
  isOnlyText?: boolean
}

export interface Emits {
  (key: 'showTooltip'): void
  (key: 'hideTooltip'): void
}

const props = withDefaults(defineProps<Props>(), {
  top: '',
  bottom: '',
  left: '',
  zIndex: 1,
  iconColor: '#C3C4C5',
  iconWidth: '14px',
  fontWeight: 'normal',
  fontSize: '14px',
})
const emits = defineEmits<Emits>()

const styles = computed<Record<string, string>>(() => ({
  top: props.top,
  left: props.left,
  bottom: props.bottom,
  width: props.width,
  zIndex: String(props.zIndex),
  position: 'absolute'
}))

const iconStyle = computed<Record<string, string>>(() => ({
  flexBasis: props.iconWidth,
  minWidth: props.iconWidth
}))

const labelStyle = computed<Record<string, string>>(() => ({
  fontWeight: props.fontWeight,
  fontSize: props.fontSize
}))

</script>

<template>
  <div class="tooltipBox">
    <div v-show="label" class="tooltipBox__label" :style="labelStyle">{{ label }}</div>
    <KkIcon v-if="!isOnlyText" :style="iconStyle" name="hint" :color="iconColor" @mouseover="emits('showTooltip')" @mouseleave="emits('hideTooltip')" />
    <div v-show="isVisible" class="tooltip" :style="styles">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tooltip {
  padding: 16px;
  border-radius: 4px;
  background: rgba(0, 0, 0, .8);
  color: white;
  @media screen and (max-width: 576px) {
    width: 300px !important;
  }
}
.tooltipBox {
  display: inline-flex;
  position: relative;
}
.tooltipBox__label {
  margin-right: 8px;
}
</style>
